import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";

const SITE = "https://regnav.in";

export function PageSeo({ title, description, path }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE}${path}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE}${path}`} />
    </Helmet>
  );
}

export function Crumbs({ items }) {
  return (
    <p className="text-xs text-[#475569] mb-5" data-testid="explore-crumbs">
      {items.map((it, i) => (
        <span key={it.name}>
          {i > 0 && " › "}
          {it.to ? <Link to={it.to} className="hover:text-[#1D4ED8]">{it.name}</Link> : it.name}
        </span>
      ))}
    </p>
  );
}

export function CtaBlock() {
  return (
    <div className="flex flex-wrap gap-3 mt-8">
      <Link to="/wizard" className="inline-flex items-center gap-2 bg-[#1D4ED8] text-white rounded-md px-5 py-3 text-sm font-bold hover:bg-[#1638A8] transition-colors" data-testid="explore-cta-wizard">
        Map my project's full approval roadmap <ArrowRight size={15} />
      </Link>
      <Link to="/analyzer" className="inline-flex items-center gap-2 bg-[#059669] text-white rounded-md px-5 py-3 text-sm font-bold hover:bg-[#059669]/90 transition-colors" data-testid="explore-cta-analyzer">
        Should my business switch to green power?
      </Link>
    </div>
  );
}

export function Disclaimer({ children }) {
  return <p className="text-xs text-[#475569] mt-8">{children || "Indicative guidance from the RegNav knowledge base, expert-verified by Solarian. Not legal advice — always verify with the concerned authority."}</p>;
}

export function Faq({ faqs }) {
  return (
    <section className="mt-10">
      <h2 className="font-serif text-xl text-[#0B1F3A] mb-3">Frequently asked questions</h2>
      {faqs.map((f) => (
        <div key={f.q} className="bg-white border border-[#0B1F3A]/10 rounded-xl px-5 py-4 mb-3">
          <h3 className="font-serif font-semibold text-[#0B1F3A] text-sm">{f.q}</h3>
          <p className="text-sm text-[#475569] mt-1">{f.a}</p>
        </div>
      ))}
    </section>
  );
}

export function SectionH({ children }) {
  return <h2 className="font-serif text-xl text-[#0B1F3A] mt-10 mb-3">{children}</h2>;
}

export function KvTable({ rows }) {
  return (
    <div className="overflow-x-auto bg-white border border-[#0B1F3A]/10 rounded-xl">
      <table className="w-full text-sm">
        <tbody>
          {rows.filter(Boolean).map(([k, v]) => (
            <tr key={k} className="border-b border-[#0B1F3A]/8 last:border-0">
              <th className="text-left align-top px-4 py-3 bg-[#0B1F3A]/[0.03] text-xs uppercase tracking-wider text-[#475569] w-52">{k}</th>
              <td className="px-4 py-3 text-[#0B1F3A]">{v}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
